<template>
    <div>
        <div v-if="editor">
            <button
                :class="{ 'is-active': editor.isActive('bold') }"
                @click="editor.chain().focus().toggleBold().run()"
            >
                <BoldIcon class="w-5" />
            </button>
            <button
                :class="{ 'is-active': editor.isActive('italic') }"
                @click="editor.chain().focus().toggleItalic().run()"
            >
                <ItalicIcon class="w-5" />
            </button>
            <button
                :class="{ 'is-active': editor.isActive('strike') }"
                @click="editor.chain().focus().toggleStrike().run()"
            >
                <StrikeIcon class="w-5" />
            </button>
            <button @click="editor.chain().focus().setHorizontalRule().run()">
                <HorizontalRule class="w-5" />
            </button>
            <button @click="editor.chain().focus().setHardBreak().run()">
                <HardBreakIcon class="w-5" />
            </button>
            <button @click="editor.chain().focus().undo().run()">
                <UndoIcon class="w-5" />
            </button>
            <button @click="editor.chain().focus().redo().run()">
                <RedoIcon class="w-5" />
            </button>
        </div>

        <div
            class="block w-full px-3 py-2 text-black placeholder-gray-400 transition duration-100 ease-in-out bg-white border border-gray-300 rounded shadow-sm min-h-20"
        >
            <EditorContent :editor="editor" />
        </div>
    </div>
</template>

<script>
    import { Editor, EditorContent } from '@tiptap/vue-2';
    import StarterKit from '@tiptap/starter-kit';
    import BoldIcon from './Icons/BoldIcon.vue';
    import ItalicIcon from './Icons/ItalicIcon.vue';
    import StrikeIcon from './Icons/StrikeIcon.vue';
    import HorizontalRule from './Icons/HorizontalRule.vue';
    import HardBreakIcon from './Icons/HardBreakIcon.vue';
    import UndoIcon from './Icons/UndoIcon.vue';
    import RedoIcon from './Icons/RedoIcon.vue';

    export default {
        components: {
            EditorContent,
            BoldIcon,
            ItalicIcon,
            StrikeIcon,
            HorizontalRule,
            HardBreakIcon,
            RedoIcon,
            UndoIcon,
        },

        props: {
            value: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                editor: null,
            };
        },

        watch: {
            value(value) {
                // HTML
                const isSame = this.editor.getHTML() === value;

                // JSON
                // const isSame = this.editor.getJSON().toString() === value.toString()

                if (isSame) {
                    return;
                }

                this.editor.commands.setContent(this.value, false);
            },
        },

        mounted() {
            this.editor = new Editor({
                extensions: [StarterKit],
                content: this.value,
                onUpdate: () => {
                    // HTML
                    this.$emit('input', this.editor.getHTML());

                    // JSON
                    // this.$emit('input', this.editor.getJSON())
                },
            });
        },

        beforeDestroy() {
            this.editor.destroy();
        },
    };
</script>

<style scoped>
    /* Optional: enforce min-height in rems or lines */
    .ProseMirror {
        min-height: 10rem;
        /* line-height: 1.5; padding gives a better feel */
    }
</style>
